import css from './CCRecapCardDelete.module.scss'
import React, { PropsWithChildren } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

import { BalloonSize, BalloonTipPosition, ComponentColor } from 'meta/backendControlled/structure'
import { ICardItem } from 'meta/pages/profile'

import {
  ActionColor,
  ActionFormat,
  ButtonTransparent,
  ButtonWhiteBlack,
  ButtonWhiteRed,
} from 'components/Actions/Action'
import BalloonWrapper from 'components/Layout/BalloonWrapper'
import Img from 'components/Media/Img'

interface Props {
  bgColor?: ComponentColor
  onClose: () => void
  cardToDelete: ICardItem
  undoCallback: () => void
  deleteCallback: () => void
}

const CCRecapCardDelete: React.FC<PropsWithChildren<Props>> = (props) => {
  const { bgColor, onClose, cardToDelete, deleteCallback, undoCallback } = props

  const { t } = useTranslation()

  return ReactDOM.createPortal(
    <div className={css.balloonBoxModal} data-modalclose="skip">
      <BalloonWrapper color={bgColor as ComponentColor} size={BalloonSize.small} tipPosition={BalloonTipPosition.right}>
        <ButtonTransparent
          format={ActionFormat.circle}
          onClick={onClose}
          className={css.balloonBoxModal__btnClose}
          hover={ActionColor.transparent}
        >
          <Img src="/icons/close_icon_white.svg" />
        </ButtonTransparent>
        <div className={css.balloonBoxModal__container}>
          <div className={css.popupModal}>
            <h4 className={css.text}>
              {`${t('checkout:card_ask_remove')} ${cardToDelete.brand} ${t('checkout:card_ending_width')} ****${
                cardToDelete.lastDigits
              }?`}
            </h4>

            <div className={css.buttons}>
              <ButtonWhiteBlack className={css.cancel} onClick={undoCallback}>
                <h5>{t('checkout:card_undo')}</h5>
              </ButtonWhiteBlack>

              <ButtonWhiteRed className={css.remove} onClick={deleteCallback}>
                <h5>{t('checkout:card_remove')}</h5>
              </ButtonWhiteRed>
            </div>
          </div>
        </div>
      </BalloonWrapper>
    </div>,
    document.getElementById('root')?.children[0] as HTMLElement
  )
}

export default CCRecapCardDelete
